export default __webpack_public_path__ + "static/media/SG-Yellow-0006.0a58544d.png";